export function capitalizeFirstLetter(str) {
  return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
}

export function convertSnakeCaseToDefault(str) {
  return str
    .split("_")
    .map((item) => capitalizeFirstLetter(item))
    .join(" ");
}

export function convertToMillions(num) {
  const str = num.toString().split("").reverse().join("");
  const parts = str.match(/.{1,3}/g);
  const result = parts.join(",").split("").reverse().join("");
  return result;
}

export function validateLetters(key) {
  const validRegex = /^[a-zA-Z\s]$/;
  return validRegex.test(key) || key === "Backspace";
}

export function validateContact(key) {
  const validRegex = /^[0-9+]+$/;
  return validRegex.test(key) || key === "Backspace";
}

export function validateEmail(email) {
  const validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return validRegex.test(email);
}

// Password policy. Same rules as the backend (authentication/validators.py).
export const PASSWORD_RULES_MESSAGE =
  "Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number and a special character (for example ! @ # $ %).";

export function passwordChecks(password = "") {
  return [
    { label: "At least 8 characters", ok: password.length >= 8 },
    { label: "An uppercase letter (A–Z)", ok: /[A-Z]/.test(password) },
    { label: "A lowercase letter (a–z)", ok: /[a-z]/.test(password) },
    { label: "A number (0–9)", ok: /[0-9]/.test(password) },
    { label: "A special character (e.g. ! @ # $ %)", ok: /[^A-Za-z0-9\s]/.test(password) },
  ];
}

export function validatePassword(password = "") {
  return passwordChecks(password).every((check) => check.ok);
}

export function truncateString(str, length) {
  if (str.length <= length) {
    return str;
  } else {
    return str.slice(0, length) + "...";
  }
}
export const currnecyFormatter = (data) => {
  return Number(data)?.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export const convertTimestamp = (timestamp) => {
  // Convert the string timestamp to a number
  const timestampNumber = Number(timestamp);

  // Convert milliseconds to a Date object
  const date = new Date(timestampNumber);

  // Extract date components
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getUTCFullYear();

  // Format to DD-MM-YYYY
  return `${day}-${month}-${year}`;
};

export const formatUSD = (data, decimalPlaces = 2) => {
  if (typeof data === "string") {
    // Attempt to parse the string into a number
    const parsedData = parseFloat(data.replace(/,/g, ""));
    if (isNaN(parsedData)) {
      return "Invalid number"; // Handle invalid input
    }
    return parsedData.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
  }

  if (typeof data === "number") {
    // Handle number directly
    return data.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
  }

  return "Invalid input"; // Handle any non-string, non-number input
};

export const formatUSDExact = (data) => {
  if (data === null || data === undefined || data === "") return "-";
  
  const str = data.toString().replace(/,/g, "");
  const parts = str.split(".");
  const intPart = Number(parts[0]);
  
  if (isNaN(intPart)) return data;
  
  const isNegative = str.startsWith("-");
  const formattedInt = (isNegative ? "-$" : "$") + Math.abs(intPart).toLocaleString("en-US");
  
  if (parts.length > 1) {
    let decimalPart = parts[1];
    if (decimalPart.length === 1) {
      decimalPart = decimalPart + "0"; // Pad with a trailing zero if exactly one digit is present
    }
    return `${formattedInt}.${decimalPart}`;
  }
  
  return formattedInt;
};

export const stripHtml = (html) => {
  if (!html) return "";
  return html
    .replace(/&nbsp;/g, " ")   // Replace common HTML entities FIRST
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    // Add bullets for list items
    .replace(/<li[^>]*>/gi, "\n  • ")
    // Convert structural tags to newlines to preserve spacing
    .replace(/<(?:br\s*\/?)>/gi, "\n")
    .replace(/<\/(?:p|div|li|h[1-6])>/gi, "\n")
    .replace(/<(?:p|div|li|h[1-6])[^>]*>/gi, "\n")
    // Replace ALL other tags with a space to prevent words from sticking together
    .replace(/<[^>]*>?/gm, " ")
    // Clean up: normalize horizontal whitespace and collapse excessive newlines
    .replace(/[ \t]+/g, " ") // Collapse multiple spaces
    .replace(/^[ \t]+|[ \t]+$/gm, "") // Trim each line
    .replace(/\n{3,}/g, "\n\n") // Max two consecutive newlines
    .trim();
};

export const formatNumberWithoutDecimal = (num) => {
  if (num === null || num === undefined) return 0;
  return Number(Math.floor(num)).toLocaleString("en-US");
};
